import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import { EmployeeRoleEditComponent } from '../../../features/employee/employee-role-edit/employee-role-edit.component'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { MatButton } from '@angular/material/button'
import { DoctorService } from '../../../core/services/doctor/driver/doctor.service'
import { HealthAgentCreateComponent } from '../../../features/health-agent/doctor-create/health-agent-create.component'
import { HealthAgentEditComponent } from '../../../features/health-agent/doctor-edit/health-agent-edit.component'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {MedicService} from '../../../core/services/medic/medic/medic.service';

@Component({
  selector: 'health-agent',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormSearchComponent,
    MatButton,
    FormClientSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './health-agent.component.html',
  styleUrl: './health-agent.component.scss',
  providers: [MedicService, AuthService],
  standalone: true,
})
export class HealthAgentComponent implements OnInit {
  constructor(
    private medicService: MedicService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  // inputSearch: string = ''

  columns: any[] = [
    {
      keyColumn: 'nome_fantasia',
      key: 'nome_principal',
      description: 'Nome',
    },
    {
      keyColumn: 'telefone',
      key: 'telefone_1',
      description: 'Telefone',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'doc',
      key: 'documento_principal',
      description: 'Documento',
    },
    {
      keyColumn: 'razao_social',
      key: 'unidade_razao_social',
      description: 'Unidade',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    // {
    //   id: 'tipoMotoristaId',
    //   description: 'Tipo Motorista',
    //   type: 'select',
    //   visible: false,
    // },



    {
      id: 'nome_principal',
      description: 'Nome',
      type: 'string',
      visible: true,
    },
    {
      id: 'crm',
      description: 'CRM',
      type: 'string',
      visible: true,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen: string = 'tutor-local'

  ngOnInit() {
    // this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }


  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    if (model.cpf) {
      model.cpf = model.cpf
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list;
    this.numberRows = response.paging.total
  }

  getListItems() {
    this.loading = true
    this.medicService.listPagedMedic(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    console.log(this.searchForm)
    this.medicService
      .searchPagedMedic(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newDriver() {
    const dialogRef = this.dialog.open(HealthAgentCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(HealthAgentEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
